import { S25Util } from "../../util/s25-util";
import {
    ChangeDetectorRef,
    Component,
    OnInit,
    ChangeDetectionStrategy,
    ViewEncapsulation,
    Input,
    Output,
    EventEmitter,
    ViewChild,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { TelemetryService } from "../../services/telemetry.service";
import { S25ChatbotComponent } from "./s25.chat.bot.component";
import { S25ModalModule } from "../s25-modal/s25.modal.module";
import { S25ModalComponent } from "../s25-modal/s25.modal.component";
import { AiPricingFormulaResponse, Message, S25ChatbotService } from "./s25.chatbot.service";

@TypeManagerDecorator("s25-ng-ai-pricing-formula-chatbot")
@Component({
    selector: "s25-ng-ai-pricing-formula-chatbot",
    template: `
        @if (init) {
            <s25-ng-ai-chatbot
                #chatbot
                [welcomeMessage]="
                    'Provide the details of the pricing for this rate schedule and I will create a series of formulas'
                "
                [isLoading]="isLoading"
                (messageThreadSent)="handleMessageThreadSent($event)"
            ></s25-ng-ai-chatbot>
        }
    `,
    styles: ``,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
    imports: [FormsModule, S25ChatbotComponent, S25ModalModule],
    standalone: true,
})
export class S25PricingChatbotComponent implements OnInit {
    @Input() onChange: (query: AiPricingFormulaResponse) => AiPricingFormulaResponse = undefined;
    @Output() rateGroup = new EventEmitter();

    @ViewChild("chatbot") chatbot!: S25ChatbotComponent;

    init: boolean = false;
    isLoading: boolean = true;

    chatbotService: S25ChatbotService<AiPricingFormulaResponse> = new S25ChatbotService<AiPricingFormulaResponse>(
        "pricingFormula",
    );

    ngOnInit(): void {
        this.init = true;
        this.isLoading = false;
    }

    initModal(modal: S25ModalComponent) {
        return modal.open();
    }

    formatMessage(response: AiPricingFormulaResponse): string {
        return response.solution
            .map((step, index) => {
                const duration = step.duration_range ? `Duration Range: ${step.duration_range}` : null;
                const time = step.time_range ? `Time Range: ${step.time_range}` : null;
                const formula = `Formula: ${step.formula}`;
                const explanation = `Explanation: ${step.explanation}`;

                const parts = [duration, time, formula, explanation].filter(Boolean);
                return `Formula ${index + 1}:\n${parts.join("\n")}`;
            })
            .join("\n\n");
    }

    async handleMessageThreadSent(thread: Message[]) {
        this.isLoading = true;

        try {
            // Await AI response
            const resp = await this.chatbotService.sendMessageThread(thread);

            if (resp) {
                if (resp.solution.length == 0) {
                    this.chatbot.addResponse("An error has occurred. Please try again.");
                }

                this.chatbot.addResponse(this.formatMessage(resp));
            }
            this.isLoading = false;
        } catch {
            this.chatbot.addResponse("An error has occurred. Please try again.");
        }
    }
}
